// src/Stateview/Stateview.js
import React, { useState , useEffect} from 'react';
import Header2 from './Header2';
import Button2 from './Button2';
import ProjectSummaryTable from './ProjectSummaryTable';
import StateViewTable from './StateViewTable';
import EmployeeWeeklyView from './EmployeeWeeklyView';
import AchievementTable from './AchievementTable';
import FilterBar1 from './FilterBar1';

const ParentComponent = ({ onLogout }) => {
  const [filters, setFilters] = useState({});
  const [lastUpdated, setLastUpdated] = useState("");

  useEffect(() => {
    const today = new Date();
    today.setHours(6, 0, 0, 0);

    const formattedDate = today.toISOString().slice(0, 16).replace("T", " ");
    setLastUpdated(`Last data updated: ${formattedDate}`);
  }, []);
  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const isFilterApplied = Object.keys(filters).length > 0;

  return (
    <div>
      <Header2 onLogout={onLogout} />
      <Button2 />
      <FilterBar1 onFilter={handleFilterChange} />
      <div className="last-updated">{lastUpdated}</div>

      {isFilterApplied && (
        <>
        <ProjectSummaryTable filters={filters} />
          <AchievementTable filters={filters} />
          <StateViewTable filters={filters} />
          <EmployeeWeeklyView filters={filters} />
        </>
      )}
    </div>
  );
};

export default ParentComponent;
